<!-- Compiled at 2026-05-13T13:50:05.286Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: block" [class.fill]="true">
				<div
					class="layout-block fill"
					[style.align-items]="'inherit'"
					[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
					[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
					[style.gap]="'1em'"
				>
					<a
						routerLink="/Ssc.Tasks"
						[queryParams]="{}"
						routerLinkActive="is-current-link"
						target="_self"
					>
						<img
							style="height: 50px; margin-top: 7px"
							[src]="'/studio/assets/logo.svg' | safeUrl"
						/>
					</a>
					<div
						class="layout-block"
						[style.flex]="'1 0 auto'"
						[style.align-items]="'center'"
						[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
						[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
						[style.gap]="'1em'"
					>
						<div
							class="layout-block"
							[style.flex]="'1 0 auto'"
							[style.align-items]="'baseline'"
							[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
							[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
							[style.gap]="'0.25em 1em'"
						>
							<h2
								style="margin: 0"
								[innerHtml]="'Llama 🦙 | Expense Management Portal' | escapeHtml: 'none' | replaceNewlines: 'h2'"
							></h2>
							<div
								class="layout-block"
								[style.flex]="'1 0 auto'"
								[style.align-items]="'inherit'"
								[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
								[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
								[style.gap]="'1em'"
							></div>
							<ng-container *ngIf="Sys.Process.isProcessTask"
								><div [matMenuTriggerFor]="menu_30">
									<mat-icon
										style="cursor: pointer"
										[innerHtml]="'groups'"
										fontSet="material-icons"
										[inline]="false"
									></mat-icon>
								</div>
								<mat-menu #menu_30="matMenu" xPosition="before" yPosition="below">
									<ng-container
										*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(!Sys.Process.isAssignedTask)) as $disabled"
									>
										<button
											mat-menu-item
											class="has-click-handler"
											color="basic"
											(click)="handler_ButtonBlock_37_click_$adhoc_0($event, {  })"
											[disabled]="$disabled"
										>
											<mat-icon>{{'person_off'}}</mat-icon
											><span
												[innerHtml]="'Unassign task' | escapeHtml: 'none' | replaceNewlines: 'span'"
											></span>
										</button>
									</ng-container>
									<button
										mat-menu-item
										class="has-click-handler"
										color="basic"
										(click)="handler_ButtonBlock_38_click_$adhoc_0($event, {  })"
										[disabled]="$disabled"
									>
										<mat-icon>{{'person_search'}}</mat-icon
										><span
											[innerHtml]="'Assign task to user' | escapeHtml: 'none' | replaceNewlines: 'span'"
										></span>
									</button> </mat-menu
							></ng-container>

							<lowgile-language-switcher
								[languageBridge]="Sys.Language"
								type="pipeSeparated"
								texts="shortNames"
							/>
							<div
								class="layout-block"
								[style.align-items]="'inherit'"
								[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
								[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
								[style.gap]="'0.5em'"
							>
								<ng-container *ngIf="Sys.User.currentUser; else else12"
									><a
										style="color: inherit"
										routerLink="/Ssc.UserProfile"
										[queryParams]="{}"
										routerLinkActive="is-current-link"
										target="_self"
									>
										<div
											class="layout-block"
											[style.align-items]="'baseline'"
											[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
											[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
											[style.gap]="'0.25em'"
										>
											<mat-icon
												style="transform: translateY(6px)"
												[innerHtml]="'account_circle'"
												fontSet="material-icons"
												[inline]="false"
											></mat-icon>
											<span
												[innerHtml]="Sys.User.currentUser.getName() | escapeHtml: 'none' | replaceNewlines: 'span'"
											></span>
										</div>
									</a>
									<a
										class="has-click-handler"
										style="color: inherit"
										(click)="handler_LinkBlock_17_click_toggleLogin_0($event, {  })"
										target="_self"
									>
										<mat-icon
											style="transform: translateY(6px)"
											[innerHtml]="'logout'"
											fontSet="material-icons"
											[inline]="false"
										></mat-icon> </a
								></ng-container>
								<ng-template #else12>
									<a
										class="has-click-handler"
										style="color: inherit"
										(click)="handler_LinkBlock_20_click_toggleLogin_0($event, {  })"
										target="_self"
									>
										<mat-icon
											style="transform: translateY(6px)"
											[innerHtml]="'login'"
											fontSet="material-icons"
											[inline]="false"
										></mat-icon>
									</a>
								</ng-template>
							</div>
						</div>
					</div>
				</div>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
